import React from 'react';
import { ITaxonomyContentProps } from '../../utils/types/taxonomy';
import { useRouter } from 'next/router';
import { isEmpty } from 'lodash';
import SkeletonCategory from '../skeletons/SkeletonCategory';
import TaxonomyContext from '../../contexts/Taxonomy';
import TaxonomyContent from './TaxonomyContent';
import uniqid from 'uniqid';

const TaxonomyItemPage = (props: ITaxonomyContentProps) => {
    const router = useRouter();
    // If the page is not yet generated, this will be displayed
    // initially until getStaticProps() finishes running
    if (router.isFallback && isEmpty(props)) {
        return (
            <div className="container">
                <div className="flex justify-center">
                    <div className="h-6 bg-gray-300 animate-pulse rounded-md w-96 mt-3"></div>
                </div>
                <SkeletonCategory />
            </div>
        );
    }
    return (
        <TaxonomyContext defaultSortBy={props.defaultSortBy}>
            <TaxonomyContent
                key={uniqid()}
                fullHead={props.fullHead}
                hero={props.hero}
                categoryName={props.categoryName}
                popular={props.popular}
                taxonomyDescription={props.taxonomyDescription}
                tsFetchedData={props.tsFetchedData}
                showPerfectGiftHelper={props.showPerfectGiftHelper}
                defaultSortBy={props.defaultSortBy}
                topDescription={props.topDescription}
                guideKey={props.guideKey}
            />
        </TaxonomyContext>
    );
};

export default TaxonomyItemPage;
